// DashboardColumn Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import IntlMessage from '../../common/intl/intl_message.jsx'

class DashboardColumn extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string.isRequired,
      info: PropTypes.string.isRequired,
      twitterUrl: PropTypes.string,
      twitterTitle: PropTypes.string,
      alt: PropTypes.bool,
      size: PropTypes.oneOf(['normal', 'small']),
      children: PropTypes.node,
      filterTabs: PropTypes.array,
      onFilterTabsAction: PropTypes.func,
      tabsActive: PropTypes.string,
      count: PropTypes.number,
      total: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      title: '',
      info: '',
      twitterUrl: '',
      twitterTitle: '',
      alt: false,
      size: 'normal',
      filterTabs: [],
      onFilterTabsAction: null,
      tabsActive: '',
      count: 0,
      total: 0
    }
  }

  render () {
    const _className = classnames('dashboard-column', {
      'dashboard-column_alt': this.props.alt,
      'dashboard-column_small': this.props.size === 'small'
    })

    return (
      <div className={_className}>
        <div className='colheader'>
          <h2 className='title'>
            <IntlMessage ident={this.props.title} />
          </h2>
          <div className='info'>
            {this.props.total > 0 ? (
              <span>{this.props.count ? this.props.count : 0}</span>
            ) : (
              <span>{this.props.count ? this.props.count : ''}</span>
            )}
            {this.props.total > 0 && (
              <span>
                <IntlMessage ident='common.dashboard.from' /> {this.props.total}{' '}
              </span>
            )}
            <IntlMessage ident={this.props.info} />
          </div>
          {this._renderActionBar()}
        </div>
        <div className='colcontent'>{this.props.children}</div>
      </div>
    )
  }

  _renderActionBar () {
    const { filterTabs, onFilterTabsAction, tabsActive } = this.props
    if (filterTabs && filterTabs.length > 0) {
      return (
        <div className='actionbar'>
          <div className='colright'>
            <div className='tabbar'>
              {filterTabs.map((tabItem, idx) => (
                <div
                  key={idx}
                  className={`tabitem${
                    tabItem.ident === tabsActive ? ' active' : ''
                  }`}
                  onClick={(event) =>
                    onFilterTabsAction
                      ? onFilterTabsAction(tabItem.ident, event)
                      : null}
                >
                  <IntlMessage ident={tabItem.label} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )
    }

    return ''
  }
}

export default DashboardColumn
